var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 165,
    viewBox: "0 0 155 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410097613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 71.1802V19.7002L37.38 49.3302L51.67 60.6502L37.38 78.6802V100.8L0 71.1802Z",
    fill: "white",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6602 0H125.86L102.62 28.91L66.6602 0Z",
    fill: "#FD6624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.75 0H42.47L105.42 50.61L146.11 0H154.73L108.55 57.43L106.45 60.05L103.83 57.95L32.63 0.700001L31.75 0Z",
    fill: "#FFCB37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 135.37V83.9004L37.38 113.52V165L0 135.37Z",
    fill: "#2B515B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 71.1802V59.9502V3.99023L36.9 31.0202L10.39 64.5702L10.5 159.21L0 150.89V71.1802Z",
    fill: "#FFCB37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0 7.98V0H54.88L82.43 21.84L57.38 53.45L0 7.98Z",
    fill: "#0A5467"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutShape);
export default __webpack_public_path__ + "static/media/about-shape.14c0562d2d2679e73de7ef73fd71c0b8.svg";
export { ForwardRef as ReactComponent };